class ProductAccordion extends HTMLElement {
  connectedCallback() {
    const dom = this.querySelector('.product-accordion-part');
    if (!dom) return;

    // 初始化 Swiper
    const swipers = dom.querySelectorAll('.swiper');
    swipers.forEach(swiper => {
      new Swiper(swiper, {
        lazy: {
          loadPrevNext: true, // 提前加载前后两张
        },
        slidesPerView: 4,
        spaceBetween: 15,
        pagination: {
          el: swiper.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          0: {  // 移动端
            slidesPerView: 2,
            grid: {
              rows: 2,
              fill: 'row',
              rowGap: 20
            },
            spaceBetween: 10
          },
          1024: {  // PC
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
      });
    });

    // Accordion 逻辑
    const root = dom.querySelector('.product-accordion-content');
    if (!root) return;

    const items = Array.from(root.querySelectorAll('[data-acc-item]'));
    const defaultOpenIndex = parseInt(root.dataset.defaultOpen, 10) - 1;

    const getPanel = item => item.querySelector('.accordion-panel');
    const getList = panel => panel.querySelector('.product-list');

    const recalc = panel => {
      const list = getList(panel);
      if (!list) return;
      panel.style.maxHeight = '0px';
      panel.style.maxHeight = list.scrollHeight + 'px';
    };

    const observePanel = panel => {
      panel.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', () => recalc(panel), { once: true });
      });

      if (!panel._ro) {
        const ro = new ResizeObserver(() => recalc(panel));
        ro.observe(getList(panel));
        panel._ro = ro;
      }

      window.addEventListener('resize', () => recalc(panel));
    };

    const closeItem = item => {
      if (!item.classList.contains('is-open')) return;
      const panel = getPanel(item);
      const list = getList(panel);

      item.querySelector('[data-acc-trigger]').setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.overflow = 'hidden';
      panel.style.maxHeight = list.scrollHeight + 'px';

      requestAnimationFrame(() => {
        panel.style.maxHeight = '0px';
      });

      item.classList.remove('is-open');
    };

    const openItem = item => {
      if (item.classList.contains('is-open')) return;
      const panel = getPanel(item);

      item.querySelector('[data-acc-trigger]').setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.style.maxHeight = '0px';

      item.classList.add('is-open');
      observePanel(panel);

      requestAnimationFrame(() => recalc(panel));

      window.addEventListener('load', () => recalc(panel), { once: true });
    };

    // 默认展开
    if (items[defaultOpenIndex]) openItem(items[defaultOpenIndex]);

    // 点击触发
    root.addEventListener('click', e => {
      const trigger = e.target.closest('[data-acc-trigger]');
      if (!trigger) return;

      const item = trigger.closest('[data-acc-item]');
      const isOpen = item.classList.contains('is-open');
      const singleMode = true;

      if (singleMode) items.forEach(it => { if (it !== item) closeItem(it); });
      isOpen ? closeItem(item) : openItem(item);
    });
  }
}

// 注册自定义元素
reg("product-accordion", ProductAccordion);
